export default __webpack_public_path__ + "static/articles-lutein-first-aid-b64ef4d97123a524ba2cb02280ed886c.jpg";